import { useTranslation } from 'react-i18next';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ILanguageSelectorProps from '../models/language-selector.props.interface';
import React from 'react';

const languages = ['HU', 'EN', 'DE', 'FR'];

const LanguageSelector: React.FC<ILanguageSelectorProps> = ({ selectedLanguage, setLanguage }) => {
  const { t } = useTranslation();

  return (
    <div className='language-selector'>
      <FormControl fullWidth>
        <InputLabel id=''>{t('language')}</InputLabel>
        <Select value={selectedLanguage} label={t('language')} onChange={e => setLanguage(e.target.value)}>
          {languages.map(language => (
            <MenuItem key={language} value={language.toLowerCase()}>
              {language}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default LanguageSelector;
